import Ajax from "Pub/js/ajax";
import { langCheck, GetQuery, getRandomValue } from 'Pub/js/utils';
import * as utilService from './utilService';
import platform from "Pub/js/platform";
import update from 'immutability-helper';
const { PubSub } = platform;
/**
 * 新增区域
 *
 * @param {*} props
 * @param {*} items - 区域属性
 * @param {*} position - 新增到指定的位置
 * @param {*} isExpand - 是否展开新增的区域
 */
export function addNewAreaItem(props, {
    items,
    position,
    isExpand = false,
}) {
    let newAreaPk = getRandomValue() + '';
    const areaList = _.cloneDeep(props.areaList);
    const newAreaData = {
        pk_area: newAreaPk.slice(newAreaPk.indexOf('.') + 1) + '', //去掉小数点目的是className如果有"."的话，querySelector会报错
        newArea: true, //用于区分新增的区域
        key: areaList.length,
        templetid: props.templetid,
        name: '',
        code: '',
        metaid: '',
        metaname: '',
        areatype: '1',
        areastatus: 'browse',
        relationcode: '',
        isunfold: true,
        isgrandson: false, //是否孙表
        associatedtab: '', //多页签关联区域
        associatedtablayout: '', //多页签布局方式
        tabheadcode: '', //多页签主表
        isclosequickquery: false, //是否关闭快速查询
        queryPropertyList: [],
        formPropertyList: [],
    };
    const newData = Object.assign(newAreaData, items);
    if (newAreaData.areatype === "2" && newData.isgrandson === undefined) {
        newAreaData.isgrandson = null;
    }
    if (newAreaData.areatype === '2') {
        newAreaData.pagesize = '100';
    }
    //没传position默认为最后
    if (position === undefined) {
        position = areaList.length;
    }
    areaList.splice(position, 0, newData);
    if (isExpand) {
        areaList[position].isShow = true; //展开新增区域
    }
    props.updateAreaList(areaList);
    props.updateSelectArea(newData); //选中新增区域
    return newData;
}

/**
 * 获取主表code
 *
 * @param {*} areaList 区域list
 * @param {*} headCode 主表code，如果store里有headcode直接返回
 * @returns
 */
export function getFormHeadCode(areaList, headCode) {
    if (headCode) {return headCode;} //如果有主表code直接返回
    const result = _.cloneDeep(areaList);
    const relationList = result.filter(item => item.relationcode); //有关联区域的区域
    const relationCodes = [...new Set(relationList.map(item => item.relationcode))]; //关联区域的code
    //拿到关联主表code
    result.forEach(area => {
        relationCodes.forEach(item => {
            if (item === area.code && area.areatype === '1') {
                headCode = item;
            }
        });
    });
    return headCode;
}

/**
 * 格式化areaList，用于渲染区域content
 *
 * @param {*} areaList 区域list
 * @param {*} headcode 主表code，从store里取的
 * @returns
 */
export function formatAreaList(areaList, headcode) {
    let result = _.cloneDeep(areaList);
    let headCode = getFormHeadCode(areaList, headcode);
    const relationList = result.filter(item => item.relationcode); //有关联区域的区域
    const relationCodes = [...new Set(relationList.map(item => item.relationcode))]; //关联区域的code
    const headArea = result.find(item => item.code === headCode); //主表区域
    const bodyArea = result.filter(area => area.areatype === '2' && relationCodes.includes(area.code)); //有侧拉的子表区域
    let bodyCodes = bodyArea && bodyArea.map(item => item.code); //子表code
    const associatedTabList = result.filter(item => item.associatedtab && checkAreaType.isTable(item)); //多页签关联区域的区域
    const associatedTabCodes = [...new Set(associatedTabList.map(item => item.associatedtab))]; //多页签关联区域的code
    const tabsArea = result.filter(area => checkAreaType.isTable(area) && associatedTabCodes.includes(area.code)); //多页签子表
    let tabsCodes = tabsArea && tabsArea.map(item => item.code); //多页签子表code
    const formTabList = result.filter(item => item.associatedtab && checkAreaType.isForm(item) && item.associatedtab === headCode); //主表多页签关联区域
    const formTabCodes = [...new Set(formTabList.map(item => item.code))]; //主表多页签code
    //表单区分组
    if (headCode) {
        const headGroupList = relationList.filter(r => isHeadGroup(r)); //主表分组
        result.find(item => {
            if (item.areatype === '1') {
                //将关联主表的区域放到主表groups中
                if (item.code === headCode && headGroupList.length > 0) {
                    item.groups = headGroupList;
                }
                formTabList.map(formTab => {
                    const headTabGroupList = relationList.filter(r => formTab.code === r.relationcode && isHeadTabGroup(r)); //主表页签分组
                    if (headTabGroupList.length > 0 && formTab.code === item.code) { //主表页签分组
                        item.groups = headTabGroupList;
                    }
                });
            }
        });
        //清空关联主表的区域
        headArea && result.map((item, index) => {
            //关联主表/页签的表单区
            if (isHeadGroup(item) || isHeadTab(item)) {
                result[index] = null;
            }
        });
    }
    //表格区侧拉&孙表
    if (bodyCodes.length > 0) {
        result.forEach(area => {
            area && bodyCodes.forEach(item => {
                if (area.code === item && area.areatype === '2') {
                    const grandsonsList = relationList.filter(r => r.relationcode === item && isGrandson(r)); //孙表
                    area.sides = relationList.filter(r => r.relationcode === item && isSide(r)); //侧拉
                    if (grandsonsList.length > 0) {area.grandsons = grandsonsList;}
                }
            });
        });
        //清空关联子表的侧拉区域
        result.map((item, index) => {
            const bodyArea = item && result.find(body => body && body.code === item.relationcode); //子表区域
            //关联子表的侧拉区/孙表
            if (bodyArea && item && bodyCodes.includes(item.relationcode) && (isSide(item) || isGrandson(item))) {
                result[index] = null;
            }
        });
    }

    //表格区多页签
    result = formatTabArea(result);

    //主表多页签(分组显示成页签)
    if (headArea && formTabList.length > 0) {
        //主表页签分组
        result.map((item, index) => {
            if (item && item.areatype === '1' && formTabCodes.includes(item.relationcode)) {
                result[index] = null;
            }
        });
        headArea.formTabs = formTabList;
    }

    //孙表多页签
    if (result.find(item => item && item.grandsons)) {
        const grandsonArea = result.filter(item => item && item.grandsons);
        grandsonArea.map(item => {
            item.grandsons = formatTabArea(item.grandsons).filter(item => item !== null);
        });
    }

    //检查是否侧拉
    function isSide(area) {
        return area.areatype === '1' && area.isgrandson !== true;
    }

    //检查是否孙表
    function isGrandson(area) {
        const relationArea = result.find(item => item && item.code === area.relationcode); //孙表关联的子表区域
        const relationCode = relationArea && relationArea.relationcode;
        return area.areatype === '2' && area.isgrandson === true && !relationCode;
    }

    //检查是否主表分组
    function isHeadGroup(area) {
        return headArea && area.relationcode === headCode && area.areatype === '1' && headArea.areatype === '1' && !area.associatedtab;
    }

    //检查是否主表页签
    function isHeadTab(area) {
        return headArea && area.associatedtab === headCode && area.areatype === '1' && headArea.areatype === '1';
    }

    //检查是否主表页签分组
    function isHeadTabGroup(area) {
        return headArea && formTabCodes.includes(area.relationcode) && area.areatype === '1' && headArea.areatype === '1';
    }

    //表格区多页签
    function formatTabArea(sourceArea) {
        //表格区多页签
        if (tabsCodes.length > 0) {
            sourceArea.forEach(area => {
                area && tabsCodes.forEach(item => {
                    if (area.code === item && checkAreaType.isTable(area)) {
                        area.tabs = associatedTabList.filter(r => r.associatedtab === item && checkAreaType.isTable(area)); //多页签子表
                    }
                });
            });
            //清空关联多页签子表对应的区域
            sourceArea.map((item, index) => {
                const tabArea = item && sourceArea.find(tab => tab && tab.code === item.associatedtab); //多页签子表区域
                //关联子表的侧拉区/孙表
                if (tabArea && item && tabsCodes.includes(item.associatedtab) && checkAreaType.isTable(item)) {
                    sourceArea[index] = null;
                }
            });
        }
        return sourceArea;
    }

    return result;
}

//查询全部区域
export function queryAllArea(templetId) {
    return new Promise(resolve => {
        let { json } = this.props;
        let param = GetQuery(this.props.location.search);
        let templetid = param.templetid || templetId;
        if (templetid) {
            Ajax({
                url: '/nccloud/platform/templet/queryallarea.do',
                data: { templetid },
                info: {
                    name: langCheck('102202APP-000003', "pages", json) /* 国际化处理： 区域设置*/,
                    action: langCheck('102202APP-000004', "pages", json), /* 国际化处理： 传递区域数值*/
                },
                success: res => {
                    let { success, data } = res.data;
                    if (success && data) {
                        //如果设置表头的区域值，在设计区不存在，则置空
                        let { headcode, areaList } = data;
                        let targetArea = areaList.find(item => item.code === headcode);
                        if (!targetArea) {
                            data = update(data, { headcode: { $set: '' } });
                        }
                        this.props.setZoneData(data);
                        this.props.setZoneDataFun(data);
                        // 实施态 处理
                        // this.props.isImplement && this.props.setServerData(data.areaList)
                        resolve(data);
                    }
                },
            });
        }
    });
}

//查询区域字段
export function queryTemplateProperty(templetid) {
    const { json } = this.props;
    let param = GetQuery(this.props.location.search);
    return new Promise(resolve => {
        Ajax({
            url: `/nccloud/platform/templet/querytempletpro.do`,
            info: {
                name: langCheck('ZoneSetting-000017', 'pages', json), /* 国际化处理： 单据模板设置*/
                action: langCheck('ZoneSetting-000018', 'pages', json), /* 国际化处理： 配置模板区域-配置区域查询*/
            },
            data: {
                templetid: param && param.templetid || templetid,
                // ismobile: param && param.templettype === 'mobile'
            },
            loading: true, //发送保存请求时页面显示loading
            success: res => {
                let { data, success } = res.data;
                if (success && data && data.length > 0) {
                    let areaList = [];
                    if (this.props.status === "searchTemplate") {
                        // 实施态
                        _.forEach(data, d => {
                            let tmpArea = { ...d };
                            if (tmpArea.areatype === '2') {
                                if (!tmpArea.pagesize) {
                                    tmpArea.pagesize = '100';
                                }
                            }
                            tmpArea.isShow = false; //用于表示区域展开状态
                            if (tmpArea.areatype === "0") {
                                areaList.push(tmpArea);
                            }
                        });
                    } else if (
                        this.props.status === "templateSetting" ||
                        this.props.status === "templateSetting-unit"
                    ) {
                        // 实施态
                        _.forEach(data, d => {
                            let tmpArea = { ...d };
                            if (tmpArea.areatype === '2') {
                                if (!tmpArea.pagesize) {
                                    tmpArea.pagesize = '100';
                                }
                            }
                            if (tmpArea.areatype !== "0") {
                                tmpArea.queryPropertyList =
                                    d.formPropertyList;
                                _.forEach(tmpArea.queryPropertyList, q => {
                                    (q.pk_query_property =
                                        q.pk_form_property),
                                    (q.myMetaPath = "");
                                });
                            }
                            tmpArea.isShow = false; //用于表示区域展开状态
                            areaList.push(tmpArea);
                        });
                    } else {
                        // 开发态
                        _.forEach(data, d => {
                            let tmpArea = { ...d };
                            if (tmpArea.areatype === '2') {
                                if (!tmpArea.pagesize) {
                                    tmpArea.pagesize = '100';
                                }
                            }
                            //将非查询区域的数据form转为query，queryPropertyList统一进行处理，保存时再进行转换
                            if (tmpArea.areatype !== "0") {
                                tmpArea.queryPropertyList =
                                    d.formPropertyList;
                                _.forEach(tmpArea.queryPropertyList, q => {
                                    (q.pk_query_property =
                                        q.pk_form_property),
                                    (q.myMetaPath = "");
                                });
                            }
                            tmpArea.isShow = false; //用于表示区域展开状态
                            areaList.push(tmpArea);
                        });
                    }
                    this.props.updateAreaList(areaList, true);
                    resolve(data);
                }
            },
        });
    });
}

// 公式编辑器
export function handleFormula(currentCard) {
    const { areaList, multiOptions } = this.props;
    //获取主表区域
    const getMainArea = (areaList, headcode) => {
        if (!headcode) {return;}
        return areaList.find(item => item.code === headcode);
    };
    // 获取当前区域
    const getArea = () => {
        let result;
        areaList.forEach((val, index) => {
            val.queryPropertyList.forEach((v, i) => {
                if (currentCard.areaid === v.areaid) {
                    result = val;
                    return;
                }
            });
        });
        return result;
    };
    //永文需要传参
    let codeArr = [];
    areaList.map(item => {
        codeArr.push(item.code);
    });

    if (_.isEmpty(currentCard) || _.isEmpty(areaList)) {return;}
    let headcode = areaList[0] && areaList[0].headcode;
    let area = getArea(); //当前区域
    let tab;
    //  tab页需要展示当前区域和表头区域
    //如果headcode不存在
    if (!headcode || (headcode && headcode === area.code)) {
        tab = [
            {
                tab: utilService.getMultiLangText(area, 'name', multiOptions),
                TabPaneContent: utilService.Formula,
                params: { name: area },
            },
        ];
    } else if (headcode && headcode !== area.code) {
        //如果headcode存在
        let mainArea = getMainArea(areaList, headcode); //表头区域
        tab = [
            {
                tab: utilService.getMultiLangText(area, 'name', multiOptions),
                key: 'main',
                TabPaneContent: utilService.Formula,
                params: { name: area },
            },
            {
                tab: utilService.getMultiLangText(mainArea, 'name', multiOptions),
                key: 'head',
                TabPaneContent: utilService.Formula,
                params: { name: mainArea },
            },
        ];
    }
    this.props.setFormulaInfo({ tab, regionCode: codeArr });
}

//删除选中卡片的className
export function removeSelectCardCls() {
    const $item = document.querySelectorAll(".template-setting-content .property-item");
    [...$item].forEach(item => {
        if ([...item.classList].includes("select-card")) {
            item.classList.remove("select-card");
        }
    });
}

//其他操作后选中字段 selectCard：选中的card
export function selectCardFromOther(selectCard) {
    removeSelectCardCls(); //先清空选中的card样式
    this.props.updateSelectCard(selectCard);
    this.props.updateSelectArea({}); //清空选中区域
}

//根据区域编码找出重复区域
export function findRepeatItemsByCode(areaList) {
    return areaList.filter((item, index, array) => array.some((k, index2) => item.code === k.code && index !== index2));
}

//判断区域类型
export const checkAreaType = {
    isSearch: area => area.areatype === '0', //是否查询区
    isForm: area => area.areatype === '1', //是否表单区
    isTable: area => area.areatype === '2', //是否表格区
    isFold: area => area.areatype === '1' && area.relationcode && area.isgrandson !== true && area.areastatus === 'browse', //是否展开卡片
    isSide: area => area.areatype === '1' && area.relationcode && area.isgrandson !== true && area.areastatus === 'edit', //是否侧拉
    isGrandson: area => area.areatype === '2' && area.isgrandson === true && area.relationcode, //是否孙表
    isTableTab: area => area.areatype === '2' && area.isgrandson !== true && area.associatedtab, //是否多页签子表
};

//发布订阅的动作
export const pubSubAction = {
    setActiveTabKey: "setActiveTabKey", //设置多页签子表选中页签
    isSave: "isSave", //保存标识
};

/**
 * 选中指定页签
 *
 * @param {*} activeKey 选中页签code
 * @param {*} areaCode 页签所属子表区域code
 */
export function setActiveTabKey({ activeKey, areaCode, expand }, isAsync = true) {
    let publish = isAsync ? PubSub.publish : PubSub.publishSync;
    publish(pubSubAction.setActiveTabKey, {
        activeKey,
        areaCode,
        expand,
    });
}

//切换多页签关联区域时选中对应页签
export function subscribeSetActiveKey(areaItem, callback) {
    return PubSub.subscribe(pubSubAction.setActiveTabKey, (action, data) => {
        const { areaCode, activeKey, expand } = data;
        if (areaCode === '') {
            callback && callback(areaCode, expand);
        } else if (areaItem.code === areaCode && activeKey) {
            callback && callback(activeKey, expand);
        }
    });
}

export function setCardSelect(card) {
    removeSelectCardCls(); //先清空选中的card样式
    this.props.updateSelectCard(card);
}

//左侧栏宽度
export const LEFT_SIDER_WIDTH = 279;

//多页签字段标示
export const TAB_FLAG = {
    table: 'tabs',
    form: 'formTabs',
};

//211新增：是否开启组织权限
export function queryOrgAuthority(refname, callback) {
    const { json } = this.props;
    Ajax({
        url: `/nccloud/platform/templet/isShowGroup.do`,
        data: { refname },
        info: {
            name: langCheck('ZoneSetting-000340', 'pages', json), /* 国际化处理： 是否开启组织权限 */
            action: langCheck('ZoneSetting-000341', 'pages', json), /* 国际化处理： 显示是否开启组织权限 */
        },
        success: res => {
            let { data, success } = res.data;
            if (success) {
                callback && callback(data);
            }
        },
    });
}

// 根据card获取当前区域
export function getAreaByCard(card, areaList) {
    let result;
    areaList.forEach(val => {
        val.queryPropertyList.forEach((v, i) => {
            if (card.areaid === v.areaid) {
                result = val;
                return;
            }
        });
    });
    return result;
}
